import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import QRCode from "react-qr-code";
import { useTranslation } from "react-i18next";

const QRSection = () => {
  const { t } = useTranslation();
  // Get the current page URL for the QR code including hash route
  const currentUrl = `${window.location.origin}${window.location.pathname}${window.location.hash}`;

  // Ensure we always show the founders page URL in the display
  const displayUrl = currentUrl.includes("#/founders") ? currentUrl : `${window.location.origin}/#/founders`;

  return (
    <section className="qr-section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Card className="qr-card text-center">
              <Card.Body>
                <h3 className="qr-title mb-4">{t("landing.founders.qr.title")}</h3>
                <p className="qr-description mb-4">{t("landing.founders.qr.description")}</p>

                <div className="qr-code-container mb-4">
                  <div className="qr-code-wrapper">
                    <QRCode
                      size={200}
                      style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                      value={currentUrl}
                      viewBox={`0 0 256 256`}
                      bgColor="#ffffff"
                      fgColor="#000000"
                      level="M"
                    />
                  </div>
                </div>

                <div className="qr-instructions">
                  <Row className="g-3">
                    <Col md={4}>
                      <div className="instruction-item">
                        <div className="instruction-icon">📱</div>
                        <div className="instruction-text">
                          <strong>{t("landing.founders.qr.step1Title")}</strong>
                          <br />
                          <small>{t("landing.founders.qr.step1Description")}</small>
                        </div>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="instruction-item">
                        <div className="instruction-icon">👆</div>
                        <div className="instruction-text">
                          <strong>{t("landing.founders.qr.step2Title")}</strong>
                          <br />
                          <small>{t("landing.founders.qr.step2Description")}</small>
                        </div>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="instruction-item">
                        <div className="instruction-icon">💼</div>
                        <div className="instruction-text">
                          <strong>{t("landing.founders.qr.step3Title")}</strong>
                          <br />
                          <small>{t("landing.founders.qr.step3Description")}</small>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="qr-url mt-3">
                  <small className="text-muted">
                    {t("landing.founders.qr.linksTo")}: <br />
                    <code>{displayUrl}</code>
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default QRSection;
